import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  country: {
    id: 'country',
    defaultMessage: 'Country',
    description: 'Text label for users country'
  },

  city: {
    id: 'city',
    defaultMessage: 'City',
    description: 'Text label for users city'
  },

  apartment: {
    id: 'apartment',
    defaultMessage: 'Apartment',
    description: 'Text label for users apartment'
  },

  aptOrSuite: {
    id: 'aptOrSuite',
    defaultMessage: 'Apt or Suite',
    description: 'Text label for users apt or suite'
  },

  streetAddress: {
    id: 'streetAddress',
    defaultMessage: 'Street address',
    description: 'Text label for users street address'
  },

  cvv: {
    id: 'cvv',
    defaultMessage: 'CVV',
    description: 'Text label for users cvv'
  },

  cardExpiration: {
    id: 'cardExpiration',
    defaultMessage: 'Card Expiration Date',
    description: 'Text label for users card expiration date'
  },

  monthYearShort: {
    id: 'monthYearShort',
    defaultMessage: 'MM/YY',
    description: 'Text label for users expiration date'
  },

  creditCardNumber: {
    id: 'creditCardNumber',
    defaultMessage: 'Credit Card Number',
    description: 'Text label for users credit card number'
  },

  nameOnCard: {
    id: 'nameOnCard',
    defaultMessage: 'Name on card',
    description: 'Text label for users name on card'
  },

  credit: {
    id: 'credit',
    defaultMessage: 'Credit',
    description: 'Text label for users credit card'
  },

  pleaseEnterYourCreditCardInformation: {
    id: 'pleaseEnterYourCreditCardInformation',
    defaultMessage: 'Please enter your credit card information',
    description: 'Text prompting for users card information'
  }
});
